<template>
    <v-app-bar
            app
            :clipped-left="clippedLeft"
            class="amber"
            dark
            >
            <!-- menu toggle button -->
            <v-app-bar-nav-icon @click.stop="toggleMenu" v-if="hasMenu"></v-app-bar-nav-icon>
            <!--Title-->
            <v-app-bar-title><slot name="title">Title</slot></v-app-bar-title>

            <!--
            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn text>Link One</v-btn>
                <v-btn text>Link Two</v-btn>
                <v-btn text>Link Three</v-btn>
            </v-toolbar-items>
            -->


            <v-spacer></v-spacer>
            <!--
            <div class="hidden-sm-and-down md4">
                <v-icon>domain</v-icon> {{$store.state.client.name}}
            </div>
            --->
            <slot></slot>
            <!--
            <select-locale outline color="teal darken-3" dark small
                           secondary-color="white"
                           secondary-class="black--text"
                           :secondary-dark="true"></select-locale>-->
            <v-btn v-if="user" icon large @click.stop="toggleUserPanel" class="ml-2">
                <v-avatar
                        v-if="user.avatar"
                        size="32px" tile right
                        >
                        <img :src="user.avatar" :alt="user.name" />
                </v-avatar>
                <v-avatar  v-else
                           class="light-green"
                            right>
                    <span class="white--text text-h5">{{user.name | charAvatar}}</span>
                </v-avatar>
            </v-btn>
            <v-btn v-else
                   icon
                   color="secondary"
                   @click.stop="toggleUserPanel">
                <v-icon>vpn_key</v-icon>
            </v-btn>
    </v-app-bar>
</template>
<script>
import {mapState} from 'vuex';

export default {
        props: {
            clippedLeft:{type:Boolean,default:false},
            hasMenu:{type:Boolean,default:true},
        },
        data() {
            return {}
        },
        mounted() {
        },
        computed: {

            ...mapState(['user'])
        },
        methods: {
            toggleMenu(){ this.$emit('toggleMenu'); },
            toggleUserPanel(){ this.$emit('toggleUserPanel'); },
        },

        components: {},
        filters: {
            charAvatar(s){return s.toUpperCase().substr(0,2);}
        }
    }
</script>
